import { createSelector } from "reselect"

export const selectPosition = state => state.userposition

export const selectUserPosition = createSelector(
  selectPosition, userposition => Object.values(userposition)
)


// WEBPACK FOOTER //
// src/data/userposition/selectors.js